
import * as fromClient from './../reducers/client.reducers';
import { IClient } from './../reducers/client.reducers';
import { Action } from '@ngrx/store';
import { HideLoader, ShowLoader } from 'src/app/shared/decorators/loader';

export const GET_CLIENT_GROUPS = 'GET_CLIENT_GROUPS';
export const GET_INITIAL_CLIENT_GROUPS = 'GET_INITIAL_CLIENT_GROUPS';
export const SET_CLIENT_GROUPS = 'SET_CLIENT_GROUPS';
export const SET_INITIAL_CLIENT_GROUPS = 'SET_INITIAL_CLIENT_GROUPS';
export const SET_SELECTED_CLIENT_GROUP = 'SET_SELECTED_CLIENT_GROUP';
export const GET_CLIENT_INVESTOR_ENTITIES = 'GET_CLIENT_INVESTOR_ENTITIES';
export const FILTER_RETRIEVED_KIWISAVER_INVESTOR_ENTITIES = 'FILTER_RETRIEVED_KIWISAVER_INVESTOR_ENTITIES';
export const GET_CLIENT_GROUP_ENTITIES_SUCCESS = 'GET_CLIENT_GROUP_ENTITIES_SUCCESS';
export const GET_CLIENT_GROUP_ENTITIES_FAIL = 'GET_CLIENT_GROUP_ENTITIES_FAIL';
export const SET_SELECTED_CLIENT_GROUP_ENTITIES = 'SET_SELECTED_CLIENT_GROUP_ENTITIES';
export const SET_SELECTED_SINGLE_ENTITY_CLIENT = 'SET_SELECTED_SINGLE_ENTITY_CLIENT';
export const GET_SINGLE_ENTITY_PORTFOLIO_SUCCESS = 'GET_SINGLE_ENTITY_PORTFOLIO_SUCCESS';
export const GET_SINGLE_ENTITY_PORTFOLIO_FAIL = 'GET_SINGLE_ENTITY_PORTFOLIO_FAIL';
export const UPDATE_ENTITY_DATE_DATA = 'UPDATE_ENTITY_DATE_DATA';
export const CLIENT_DATA_ERROR = 'CLIENT_DATA_ERROR';
export const GET_AVAILABLE_POSITIONS = 'GET_AVAILABLE_POSITIONS';
export const SET_AVAILABLE_POSITIONS = 'SET_AVAILABLE_POSITIONS';
export const CLEAR_CLIENT_DATA = 'CLEAR_CLIENT_DATA';

export class GetInitialClientGroups implements Action {
    readonly type = GET_INITIAL_CLIENT_GROUPS;
}
export class SetInitialClientGroups implements Action {
    readonly type = SET_INITIAL_CLIENT_GROUPS;
    constructor(public payload: IClient[]) { }
}
export class GetClientGroups implements Action {
    readonly type = GET_CLIENT_GROUPS;
    constructor(public payload: fromClient.IClientSearchModel) { }
}
export class SetClientGroups implements Action {
    readonly type = SET_CLIENT_GROUPS;
    constructor(public payload: IClient[]) { }
}

@ShowLoader()
export class SetSelectedClientGroup implements Action {
    readonly type = SET_SELECTED_CLIENT_GROUP;
    constructor(public payload: {
        selectedClient: fromClient.IClient;
        date: Date;
    }) { }
}

@ShowLoader()
export class SetSelectedSingleEntityClient implements Action {
    readonly type = SET_SELECTED_SINGLE_ENTITY_CLIENT;
    constructor(public payload: {
        selectedClient: fromClient.IClient;
        date: Date;
    }) { }
}

@HideLoader(SET_SELECTED_SINGLE_ENTITY_CLIENT)
export class GetSingleEntityPortfolioValueSuccess implements Action {
    readonly type = GET_SINGLE_ENTITY_PORTFOLIO_SUCCESS;
}
@HideLoader(SET_SELECTED_SINGLE_ENTITY_CLIENT)
export class GetSingleEntityPortfolioValueFail implements Action {
    readonly type = GET_SINGLE_ENTITY_PORTFOLIO_FAIL;
}

@HideLoader(SET_SELECTED_CLIENT_GROUP)
export class GetClientGroupEntitiesSuccess implements Action {
    readonly type = GET_CLIENT_GROUP_ENTITIES_SUCCESS;
}
@HideLoader(SET_SELECTED_CLIENT_GROUP)
export class GetClientGroupEntitiesFail implements Action {
    readonly type = GET_CLIENT_GROUP_ENTITIES_FAIL;
}


export class SetSelectedClientGroupEntities implements Action {
    readonly type = SET_SELECTED_CLIENT_GROUP_ENTITIES;
    constructor(public payload: any) { }
}
export class GetClientInvestorEntities implements Action {
    readonly type = GET_CLIENT_INVESTOR_ENTITIES;
    constructor(public payload: Date) { }
}

export class FilterRetrievedKiwiSaverInvestorEntities implements Action {
    readonly type = FILTER_RETRIEVED_KIWISAVER_INVESTOR_ENTITIES;
    constructor(public payload: any) { }
}
export class UpdateEntityDateData implements Action {
    readonly type = UPDATE_ENTITY_DATE_DATA;
    constructor(public payload: any) { }
}

export class ClientDataError implements Action {
    readonly type = CLIENT_DATA_ERROR;
    constructor(public payload: string) { }
}
export class GetAvailablePositions implements Action {
    readonly type = GET_AVAILABLE_POSITIONS;
    constructor(public payload: string = '') { }
}
export class SetAvailablePositions implements Action {
    readonly type = SET_AVAILABLE_POSITIONS;
    constructor(public payload: any) { }
}

export type ClientActions = GetClientGroups | GetInitialClientGroups | SetInitialClientGroups | SetClientGroups |
    SetSelectedClientGroup | GetClientInvestorEntities | FilterRetrievedKiwiSaverInvestorEntities | SetSelectedClientGroupEntities | UpdateEntityDateData |
    ClientDataError | SetSelectedSingleEntityClient | GetAvailablePositions | SetAvailablePositions;
